import { render } from "./Account-Base.vue?vue&type=template&id=59c0bfbe&scoped=true&ts=true"
import script from "./Account-Base.vue?vue&type=script&lang=ts"
export * from "./Account-Base.vue?vue&type=script&lang=ts"

import "./Account-Base.vue?vue&type=style&index=0&id=59c0bfbe&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c0bfbe"]])

export default __exports__